// libraries
import { atom, atomFamily, selector } from 'recoil';

/** 마커 전체 리스트 */
export const MarkerAtomFamily = atomFamily({
  key: 'MarkerAtomFamily',
  default: []
});

/** 마커 추가 모드 */
export const MarkerCreateModeAtom = atom({
  key: 'MarkerCreateModeAtom',
  default: false
});

/** 선택된 마커 */
export const SelectedMarkerAtom = atom({
  key: 'SelectedMarkerAtom',
  default: null
});

/** 마커 리스트를 위한 selector */
export const MarkerListSelector = selector({
  key: 'MarkerListSelector',
  get: ({ get }) => {
    return get(MarkerAtomFamily('all'));
  }
});

/** 카메라 이동 마커 */
export const CameraMoveMarkerAtom = atom({
  key: 'CameraMoveMarkerAtom',
  default: null
});
